import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import {
  ConfirmEmailPayload,
  RequestConfirmEmailOtpPayload,
  RequestOtpPayload,
  ResetPasswordPayload,
  VerifyPasswordResetOtpPayload,
} from 'sham-components/shared/models/auth';
import { AppEnvironment } from './core/app-environment';

@Injectable({
  providedIn: 'root',
})
export class AuthApi {
  private readonly http = inject(HttpClient);
  private readonly appEnv = inject(AppEnvironment);
  private readonly BASE_URL = computed(() => `${this.appEnv.API_BASE_URL()}/v1/auth`);

  requestPasswordResetOtp(payload: RequestOtpPayload) {
    return this.http.post(this.BASE_URL() + '/password-reset/request-otp', payload);
  }

  verifyPasswordResetOtp(payload: VerifyPasswordResetOtpPayload) {
    return this.http.post<{ resetToken: string }>(
      '/api/auth/password-reset/verify-otp',
      payload,
    );
  }

  resetPassword(payload: ResetPasswordPayload) {
    return this.http.post(this.BASE_URL() + '/reset-password', payload);
  }

  requestConfirmEmailOtp(payload: RequestConfirmEmailOtpPayload) {
    return this.http.post(
      this.BASE_URL() + '/auth/email-confirmation/request-otp',
      payload,
    );
  }

  confirmEmail(payload: ConfirmEmailPayload) {
    return this.http.post(
      this.BASE_URL() + '/auth/email-confirmation/confirm',
      payload,
    );
  }
}
